import { useMemo, useCallback } from "react";
import { useAppSelector } from "../../app";

export const useConfigMapCategorizations = () => {
  const configMap = useAppSelector((state) => state.configMapReducer.configMap);
  const categorizationAnnotations = useAppSelector(
    (state) =>
      state.metadataReducer.categorizationState.categorizationAnnotations,
  );

  const categorizationLinks = useMemo(() => {
    if (!configMap?.categorizationLinks) {
      return [];
    }

    return configMap.categorizationLinks
      .filter((link) => link.configMapId)
      .map((link) => ({
        id: link.id,
        categorization: link.categorization,
        required: link.required,
      }));
  }, [configMap]);

  const sortedCategorizationLinks = useMemo(() => {
    return categorizationLinks.sort(
      (a, b) =>
        (a.categorization.index ?? Number.MAX_VALUE) -
        (b.categorization.index ?? Number.MAX_VALUE),
    );
  }, [categorizationLinks]);

  const getAnnotationValue = useCallback(
    (categorizationId: string, index: number = 1): string | undefined => {
      return categorizationAnnotations?.find(
        (ca) => ca.categorizationId === categorizationId && ca.index === index,
      )?.value;
    },
    [categorizationAnnotations],
  );

  const hasRequiredCategorization = useCallback(
    (categorizationId: string): boolean => {
      return categorizationLinks.some(
        (link) => link.categorization.id === categorizationId && link.required,
      );
    },
    [categorizationLinks],
  );

  return {
    categorizationLinks: sortedCategorizationLinks,
    getAnnotationValue,
    hasRequiredCategorization,
  };
};
